import { useParams } from 'react-router-dom';

import { PathParams } from '@app/routes/types';

/**
 * React Hook to get a group id from React Router params :groupId.
 * To use in API calls.
 */
export const useGroupId = (): string => {
    const { [PathParams.GroupId]: groupId } = useParams();

    return groupId || '';
};
